import { render, staticRenderFns } from "./ice-hockey-icon.vue?vue&type=template&id=1406a6ce"
import script from "./ice-hockey-icon.vue?vue&type=script&lang=js"
export * from "./ice-hockey-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports